module.exports = __webpack_public_path__ + "static/chime_of_opening-790c5b6cec1cf83f2f3a3a6f6a51a736.jpeg";